module.exports = __webpack_public_path__ + "img/pd-img-head8.dcf479a3.png";